module.exports = __webpack_public_path__ + "media/luxury-2026/stanwich-architectural-living-826b8934.jpg";